"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var polished_1 = require("polished");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var field = ui_blocks_1.FORM.field,
    hasErrors = ui_blocks_1.FORM.hasErrors; // Sizes =======================================================================

var Sizes;

(function (Sizes) {
  Sizes[Sizes["small"] = 4] = "small";
  Sizes[Sizes["medium"] = 5] = "medium";
})(Sizes || (Sizes = {}));

var makeSizeStyles = function makeSizeStyles(size, theme) {
  var _a;

  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), (0, ui_symbols_1.calcSpace)(Sizes[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP));
};

var hasErrorsStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), hasErrors);
exports.Input = styled_components_1.default.input.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasErrors', 'sizeOption'].includes(prop);
  }
})(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  width: 100%;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 0 1rem;\n  &:focus {\n    padding: 0 calc(1rem - ", ");\n  }\n  ", "\n  ", "\n"], ["\n  ", "\n  width: 100%;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 0 1rem;\n  &:focus {\n    padding: 0 calc(1rem - ", ");\n  }\n  ", "\n  ", "\n"])), field, (0, polished_1.rem)(1), function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', hasErrorsStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles);
});
var templateObject_1, templateObject_2, templateObject_3;